import { render } from "./PosTicketCard.vue?vue&type=template&id=0ffb588d&ts=true"
import script from "./PosTicketCard.vue?vue&type=script&lang=ts"
export * from "./PosTicketCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__